/*
 * Copyright (C) Serfim TIC
 * All rights reserved
 */
import { RestService } from '../../RestService';

class ActionRequestService extends RestService {
    /** @ngInject */
    constructor($q, resource, $httpParamSerializerJQLike, $log) {
        super($q, resource,  $httpParamSerializerJQLike, $log, false);
        $log.debug('Service \'ActionRequestService\' loaded');
    }

    /**
     * Completes an action request.
     *
     * @param {Number} id Action request ID.
     * @returns {Promise} A promise providing the result.
     */
    complete(id) {
        return this.resource.complete({id}, {}).$promise;
    }

    /**
     * Reopens an action request.
     *
     * @param {Number} id Action request ID.
     * @returns {Promise} A promise providing the result.
     */
    reopen(id) {
        return this.resource.reopen({id}, {}).$promise;
    }

    /**
     * Closes an action request.
     *
     * @param {Number} id Action request ID.
     * @param {Object} data Data sent in the request body.
     * @returns {Promise} A promise providing the result.
     */
    close(id, data) {
        return this.resource.close({id}, data).$promise;
    }

    /**
     * Cancels an action request.
     *
     * @param {Number} id Action request ID.
     * @returns {Promise} A promise providing the result.
     */
    cancel(id) {
        return this.resource.cancel({id}, {}).$promise;
    }
}

export { ActionRequestService };



// WEBPACK FOOTER //
// ./src/main/front/scripts/module/actionrequest/service/ActionRequestService.js